'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preactFela = require('preact-fela');

var wrapperStyles = function wrapperStyles(_ref) {
  var inside = _ref.inside;
  return {
    display: 'flex',
    height: '100%',
    width: inside ? '100%' : 'auto',
    flexDirection: 'column',
    borderBottom: inside ? '1px solid #e0e0e0' : null,
    desktop: {
      position: 'relative',
      margin: '0',
      width: 'auto',
      flexDirection: 'row',
      borderBottom: 'none'
    }
  };
};

exports.default = (0, _preactFela.createComponent)(wrapperStyles);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Core/Dropdown/DropdownWrapper.js
// module id = 57
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38